module.exports = __webpack_public_path__ + "img/audi-black.9fc05056.jpg";